import { definePreset } from '@primeng/themes';
import Aura from '@primeuix/themes/aura';
 
export const StckConsumableManagerPwaPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50:  '#E6F6EF',
            100: '#C0EADC',
            200: '#99DDC8',
            300: '#73D1B5',
            400: '#4DC4A2',
            500: '#008342',
            600: '#00753A',
            700: '#006431',
            800: '#004F26',
            900: '#00381A',
            950: '#001F0D'
        }
    }
});